import request from '@/utils/request'
const baseUrl = '/newgaia48'

/**
 * Banner列表
 */
export function getBannerList() {
  return request({
    url: `${baseUrl}/getBannerList`,
    method: 'GET'
  })
}

/**
 * 48主页的内容,主办方,快捷入口等等
 */
export function getHomeSettingList() {
  return request({
    url: `${baseUrl}/getHomeSettingList`,
    method: 'GET'
  })
}

/**
 * 查看作品详情
 */
export function getDetail(hid) {
  return request({
    url: `${baseUrl}/private/exhibit-details/${hid}`,
    method: 'GET'
  })
}

/**
 * 分站赛列表 区域
 */
export function getAreas() {
  return request({
    url: `${baseUrl}/private/getAreas`,
    method: 'GET'
  })
}

/**
 * 分站赛列表 年份
 */
export function getYears() {
  return request({
    url: `${baseUrl}/private/getYears`,
    method: 'GET'
  })
}

/**
 * partyNight,传值1,2,3,4分别代表播映,颁奖,设备展,party
 */
export function getPartyNight() {
  return request({
    url: `${baseUrl}/private/rest/getPartyNight`,
    method: 'GET'
  })
}

/**
 * 获取48电影节详情
 */
export function get48info() {
  return request({
    url: `${baseUrl}/private/rest/get48info`,
    method: 'GET'
  })
}

/**
 * 获取除线上集训之外的集训内容
 */
export function getTrainSettings() {
  return request({
    url: `${baseUrl}/private/rest/getTrainSettings`,
    method: 'GET'
  })
}

/**
 * 官方新闻发布点赞/取消
 */
export function newsAgree(nid) {
  return request({
    url: `${baseUrl}/private/rest/newsAgree/${nid}`,
    method: 'GET'
  })
}

/**
 * 更新48作品
 */
export function update48Works(data) {
  return request({
    url: `${baseUrl}/private/rest/update48Works`,
    method: 'POST',
    data
  })
}

/**
 * 展映作品点赞/取消
 */
export function worksAgree(wid) {
  return request({
    url: `${baseUrl}/private/rest/worksAgree/${wid}`,
    method: 'GET',
  })
}

/**
 * 展映年度获奖,获取作品页面
 */
export function getShowWorks(data) {
  return request({
    url: `${baseUrl}/private/rest/getShowWorks`,
    method: 'POST',
    data
  })
}

/**
 * 管理个人中心48作品,默认分站赛id请传值0
 */
export function getManagePersonal48Works(data) {
  return request({
    url: `${baseUrl}/private/rest/getManagePersonal48Works`,
    method: 'POST',
    data
  })
}

/**
 * 获取个人中心48作品,默认分站赛id请传值0
 */
export function getPersonal48Works(data) {
  return request({
    url: `${baseUrl}/private/rest/getPersonal48Works`,
    method: 'POST',
    data
  })
}

/**
 * 查看新闻详情
 */
export function getNewsDetail(id) {
  return request({
    url: `${baseUrl}/private/rest/getNewsDetail/${id}`,
    method: 'GET',
  })
}

/**
 * 获取年度展映获奖,获取作品页面
 */
export function getShowWorksByYear(data) {
  return request({
    url: `${baseUrl}/private/rest/getShowWorksByYear`,
    method: 'POST',
    data
  })
}

/**
 * 获取分站赛详细情况(只包括获奖等)
 */
export function getAreaDetail(yearOrAreaid) {
  return request({
    url: `${baseUrl}/private/rest/getAreaDetail/${yearOrAreaid}`,
    method: 'GET',
  })
}

/**
 * 获取展映年度获奖情况(只包括获奖等)
 */
export function getAreaYearDetail(yearOrAreaid) {
  return request({
    url: `${baseUrl}/private/rest/getAreaYearDetail/${yearOrAreaid}`,
    method: 'GET',
  })
}

/**
 * 官方发布新闻
 */
export function getAllNews(data) {
  return request({
    url: `${baseUrl}/private/rest/getAllNews`,
    method: 'POST',
    data
  })
}

/**
 * 获取相册列表
 */
export function getAblums(data) {
  return request({
    url: `${baseUrl}/private/rest/getAblums`,
    method: 'POST',
    data
  })
}

/**
 * 获取相册详情
 */
export function getPhotoDetails(data) {
  return request({
    url: `${baseUrl}/private/rest/getPhotoDetails/${data.id}`,
    method: 'POST',
    data
  })
}

/**
 * 获取线上课程
 */
export function getOnlineClass(data) {
  return request({
    url: `${baseUrl}/private/rest/getOnlineClass`,
    method: 'POST',
    data
  })
}

/**
 * 获取参赛协议
 */
export function getAgree() {
  return request({
    url: `${baseUrl}/getAgree`,
    method: 'GET',
  })
}

/**
 * 获取成片要求
 */
export function getRequire() {
  return request({
    url: `${baseUrl}/getRequire`,
    method: 'GET',
  })
}
